import PropTypes from 'prop-types'

import ShippingsOverview from '../../ShippingsOverview'
import EmptyStateWrapper from '../../../ui/components/EmptyState/PaperWrapper'
import SearchEmptyState from '../../../ui/modules/SearchEmptyState'
import Loader from '../../../ui/views/Loader'

const LatestShipments = ({
  tableParams,
  headCells,
  rows,
  states,
  headCellsOrder,
  stepsData,
  noData,
  isLoading = true,
  selectedShippings = [],
  onCheckboxChange = () => {},
  onSelectAllClick = () => {},
  onBackToListClick = () => {},
  getActionsForRow,
  onClickResolveIncident,
}) => {
  const handleOnBackToListClick = () => {
    onBackToListClick()
  }

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : noData || rows.length === 0 ? (
        <EmptyStateWrapper>
          <SearchEmptyState onClearSearch={handleOnBackToListClick} />
        </EmptyStateWrapper>
      ) : (
        <ShippingsOverview
          tableParams={tableParams}
          headCells={headCells}
          rows={rows}
          states={states}
          headCellsOrder={headCellsOrder}
          stepsData={stepsData}
          onCheckboxChange={onCheckboxChange}
          getActionsForRow={getActionsForRow}
          onSelectAllClick={onSelectAllClick}
          selectedRows={selectedShippings}
          showIcon
          showMenu
          onClickResolveIncident={onClickResolveIncident}
        />
      )}
    </>
  )
}

LatestShipments.propTypes = {
  tableParams: PropTypes.shape({
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    totalRows: PropTypes.number,
    sortType: PropTypes.string,
    sortColumn: PropTypes.string,
  }),
  headCellsOrder: PropTypes.arrayOf(PropTypes.string),
  headCells: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      sortable: PropTypes.bool,
    }),
  ),
  //TODO: Review row proptypes - extract at common for reuse
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      info: PropTypes.oneOfType([
        PropTypes.shape({
          numero_colegiado: PropTypes.string,
          nombre: PropTypes.string,
          apellidos: PropTypes.string,
          modalidades: PropTypes.string,
          farmacia: PropTypes.string,
          telefono: PropTypes.string,
          correo_electronico: PropTypes.string,
        }),
        PropTypes.shape({
          nombre: PropTypes.string,
          telefono: PropTypes.string,
          correo_electronico: PropTypes.string,
          estado: PropTypes.string,
        }),
        PropTypes.shape({
          year: PropTypes.string,
          day: PropTypes.string,
          reason: PropTypes.string,
          type: PropTypes.string,
          locality: PropTypes.string,
        }),
      ]),
    }),
  ),
  stepsData: PropTypes.object,
  noData: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  states: PropTypes.array,
  selectedShippings: PropTypes.array,
  onCheckboxChange: PropTypes.func,
  getActionsForRow: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  onBackToListClick: PropTypes.func,
  onClickResolveIncident: PropTypes.func,
}

export default LatestShipments
